import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { QuestionIcon, Text, Tooltip } from '@beef/ui-kit';

import styles from './styles.pcss';
import { UnitProps } from './types';

const cn = classNames.bind(styles);

export const Unit: FC<UnitProps> = ({ unit, description }) => (
  <div className={cn('component')}>
    <Text color="grey60" size="size5-r-s">
      {unit}
    </Text>
    {description && (
      <div className={cn('tooltip')}>
        <Tooltip message={description} position="bottom">
          <QuestionIcon fill="#727281" size="s" />
        </Tooltip>
      </div>
    )}
  </div>
);
